'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErosApi = undefined;
exports.query = query;
exports.queryCanned = queryCanned;
exports.memoizeQuery = memoizeQuery;

var _FetchPeon = require('../peons/FetchPeon');

var _Configure = require('../Configure');

var _esCleanup = require('../esCleanup');

var _eventBusRx = require('event-bus-rx');

var _eventBusRx2 = _interopRequireDefault(_eventBusRx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getHeaders() {
  return {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + (0, _Configure.getConfigs)().access_token
  };
}

function _query(streamId, url, body, fetcher) {
  var results = _eventBusRx2.default.getTopic(streamId);

  var req = {
    method: 'post',
    headers: _getHeaders(),
    compress: true,
    body: body
  };
  fetcher(url, req).subscribe(function (json) {
    if (json.error) {
      _eventBusRx2.default.publish(streamId, { isLoading: false, isError: false, error: json.error });
    } else {
      _eventBusRx2.default.publish(streamId, Object.assign({ isLoading: false, isError: false }, (0, _esCleanup.esCleanup)(json)));
    }
  });

  _eventBusRx2.default.publish(streamId, { isLoading: true });

  return results;
}

function query(streamId, path, body) {
  var url = (0, _Configure.getConfigs)().erosUrl + '/esquery';
  var stringified = JSON.stringify({ path: path, body: JSON.stringify(body) });
  return _query(streamId, url, stringified, _FetchPeon.doFetch);
}

function queryCanned(streamId, path, body) {
  var url = (0, _Configure.getConfigs)().erosUrl + '/' + path;
  var stringified = JSON.stringify(body);
  return _query(streamId, url, stringified, _FetchPeon.doFetch);
}

function memoizeQuery(streamId, path, body) {
  var url = (0, _Configure.getConfigs)().erosUrl + '/esquery';
  var stringified = JSON.stringify({ path: path, body: JSON.stringify(body) });
  return _query(streamId, url, stringified, _FetchPeon.memoizeFetch);
}

// For testing
var ErosApi = exports.ErosApi = {
  memoizeQuery: memoizeQuery,
  queryCanned: queryCanned,
  query: query
};


//////////////////
// WEBPACK FOOTER
// ../~/anuket/lib/apis/ErosApi.js
// module id = 61
// module chunks = 0